<script>
    import {formatDate, getDate} from "../lib/lib";
    import ProjectSelectControl from "../components/controls/ProjectSelectControl.svelte";
    import CalendarControl from "../components/controls/CalendarControl.svelte";
    import DateControl from "../components/controls/DateControl.svelte";
    import TagsControl from "../components/controls/TagsControl.svelte";

    export let search;
    export let searchCallBack = null;

    let tags = [];

    const initialize = () => {
        // search.date_from = getDate();

        let today = new Date();
        let day = today.getDay();
        let firstDay = new Date(today.getTime() - 60 * 60 * 24 * day * 1000); //will return firstday (ie sunday) of the week
        let lastDay = new Date(firstDay.getTime() + 60 * 60 * 24 * 6 * 1000); //adding (60*60*6*24*1000) means adding six days to the firstday which results in lastday (saturday) of the week

        search.date_from = formatDate(firstDay, 'y-m-d');
        search.date_to = formatDate(lastDay, 'y-m-d');
    }

    const onSearch = () => {
        search.tags = tags.map(item => item.id);
        console.log("onSearch", search);
        searchCallBack(search);
    }

    const onClear = () => {
        initialize();
        search.name = '';
        search.project_id = null;
        search.tags = [];
        tags = [];

        onSearch();
    }

    // const dateDiff = (str1, str2) => {
    //     let diff = Date.parse(str2) - Date.parse(str1);
    //     return isNaN(diff) ? NaN : Math.ceil(diff / 86400000);
    // }

    const onDateChange = (field) => {
        if (search.date_from && search.date_to && search.date_from > search.date_to) {
            if (field === 'from') {
                search.date_to = search.date_from;
            } else {
                search.date_from = search.date_to;
            }
        }
        onSearch();
    }

    initialize();
</script>

<div class="panel-simple p-2 mb-5">
    <div class="row">
        <div class="col-xl-1">
            <DateControl bind:value="{ search.date_from }" topInfo="από" on:change={ () => onDateChange('from') }/>
        </div>
        <div class="col-xl-1">
            <DateControl bind:value="{ search.date_to }" topInfo="έως" on:change={ () => onDateChange('to') }/>
        </div>
        <div class="col-xl-2">
            <input type="text" class="form-control" bind:value="{ search.name }" on:change={ onSearch }
                   placeholder="εργασία">
        </div>
        <div class="col-xl-2">
            <ProjectSelectControl bind:projectId="{ search.project_id }" on:change={ onSearch } placeholder="project"/>
        </div>
        <div class="col-xl-4">
            <TagsControl bind:tags={ tags } clockingTask inline on:change={ onSearch }/>
        </div>
        <div class="col-xl-2 text-end">
            <button class="btn btn-default" on:click={ onClear }>ΚΑΘΑΡΙΣΜΟΣ</button>
        </div>
    </div>
</div>